import {
  type BDCollabAwareness,
  type BDCollabAwarenessChanges,
} from './collab-awareness.types';

/**
 * Abstract base class for managing Yjs Awareness.
 *
 * @template State - Represents Awareness state definition.
 */
export abstract class BDCollabAwarenessBase<State extends object> {
  constructor(public awareness: BDCollabAwareness) {
    this._onAwarenessChange();
  }

  /**
   * Updates the local Awareness state for the current user.
   * @param state - The new Awareness state.
   */
  protected setAwarenessState(state: Partial<State>) {
    const currentState = this.awareness.getLocalState() || {};
    this.awareness.setLocalState({ ...currentState, ...state });
  }

  /**
   * Retrieves the current Awareness state.
   */
  getAwarenessState(): Map<number, State> {
    return this.awareness.getStates() as Map<number, State>;
  }

  /**
   * Cleans up Awareness listeners when no longer needed.
   */
  protected destroyAwarenessChange() {
    this.awareness.off('change', this.onAwarenessChange);
  }

  private _onAwarenessChange() {
    this.awareness.on('change', (changes: BDCollabAwarenessChanges) => {
      this.onAwarenessChange(changes);
    });
  }

  /**
   * Abstract method that must be implemented in subclasses to handle Awareness changes.
   * @param changes - BDCollabAwarenessChanges.
   */
  protected abstract onAwarenessChange(changes: BDCollabAwarenessChanges): void;
}
